import { httpResource } from '@angular/common/http';
import { Component, inject, signal } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ItemListResponse } from '@models';

@Component({
  selector: 'app-resource-picker',
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './resource-picker.component.html',
  styleUrl: './resource-picker.component.scss'
})
export class ResourcePickerComponent<T extends {
  id: string;
  title: string;
  number?: number;
  area?: string;
}> {
  data = inject<{
    title: string;
    description: string;
    placeholder: string;
    label: string;
    endpoint: string;
  }>(MAT_DIALOG_DATA);

  q = signal('');
  resource = httpResource<ItemListResponse<T>>(() => `${this.data.endpoint}&q=${this.q()}`);
  selectedItem = signal<T | null>(null);

  onSearchEvent(event: Event) {
    const value = (event.target as HTMLInputElement).value || '';
    this.q.set(value);
  }
}
